var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loadingUser)?_c('div',{staticClass:"loading-general"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}]})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }